<template>
  <div class="row">
    <div class="col s12">
      <v-select
        :items="options"
        @input="handleChange"
        v-model="condition.subfield"
        hide-details
        placeholder="Select a field..."
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    condition: {
      type: Object,
      default: () => {},
    },
    template: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    options() {
      return this.template.data.subfield_options || []
    },
  },
  methods: {
    handleChange() {
      this.$emit('change', { condition: this.condition })
    },
  },
}
</script>

<style></style>
